/** Google Maps navigation helpers (Phase E). */

export function googleMapsNavigationUrl(latitude, longitude) {
  return `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}&travelmode=driving`;
}

export function openNavigation(latitude, longitude) {
  const url = googleMapsNavigationUrl(latitude, longitude);
  window.open(url, '_blank', 'noopener,noreferrer');
}

export function trackingStatusLabel(tracking) {
  if (!tracking) return 'Unknown';
  if (tracking.location_status === 'live') return 'Provider is on the way';
  if (tracking.location_status === 'stale') return 'Location updating…';
  if (tracking.travel_status === 'en_route') return 'Provider is on the way';
  if (tracking.travel_status === 'not_started') return 'Waiting for provider to start trip';
  return 'Booking confirmed';
}

/** Road ETA from Google Routes (backend). */
export function trackingEtaDisplay(tracking) {
  if (!tracking || tracking.location_status !== 'live') return null;
  if (tracking.eta_source === 'google_routes' && tracking.eta_minutes != null) {
    return {
      heading: 'Arriving in',
      minutes: tracking.eta_minutes,
      unavailable: false,
    };
  }
  if (tracking.eta_source === 'unavailable') {
    return { heading: 'ETA unavailable', minutes: null, unavailable: true };
  }
  return null;
}

/** Prefer road distance; fall back to straight-line label. */
export function trackingDistanceDisplay(tracking) {
  if (!tracking) return null;
  if (tracking.road_distance_km != null) {
    return `${tracking.road_distance_km} km away`;
  }
  if (tracking.distance_km != null) {
    return `${tracking.distance_km} km away (straight-line)`;
  }
  return null;
}
